export * from "./field-validators"
export * from "./router"
export * from "./tree"
export * from "./array-move"
export * from "./format-objects"
export * from "./controls"
export * from "./json"
export * from "./roles"
export * from "./langs"
export * from "./techfields"

// @ts-ignore
export const isIE = false || !!document.documentMode
// @ts-ignore
export const isEdge = !isIE && !!window.StyleMedia
// @ts-ignore
export const isFirefox = typeof InstallTrigger !== "undefined"

export const getBrowserName = () =>
  isEdge ? "edge" : isFirefox ? "fireFox" : "chrome"

export const isEmpty = <T extends object>(o: T) => {
  if (Array.isArray(o)) return o.length === 0
  for (let prop in o) if (o.hasOwnProperty(prop)) return false
  return true
}

export const forEachProperty = <T extends { [key: string | number]: P }, P>(
  o: T,
  fn: (value: P) => any
): void => {
  for (let prop in o) {
    fn(o[prop])
  }
}
